<div>
  <textarea #rulesInput [(ngModel)]="rulesText" rows="10" cols="80" placeholder="Enter your tennis question here..."></textarea>
</div>
<div class="button-container">
  <button (click)="submitRules()" [disabled]="isLoading || !rulesText.trim()">
    {{ isLoading ? 'Submitting...' : 'Submit' }}
  </button>
  <button (click)="clearForm()" class="clear-button" [disabled]="isLoading">
    Clear
  </button>
</div>

<div *ngIf="isLoading" class="loading">
  Loading AI response...
</div>

<div *ngIf="!aiResponse" class="response">
    Ask rule questions such as:
    <ul>
        <li>Who serves first after a tiebreaker?</li>
        <li>How much time do I get between sets?</li>
        <li>When do we switch sides in a tiebreaker?</li>
        <li>Describe the rules of the coin-toss.</li>
    </ul>
</div> 
<div *ngIf="aiResponse" class="response">
  <pre>{{ aiResponse }}</pre>
</div> 